import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--bg-page)' }}>
      <div className="container-custom py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-[var(--brand-blue)] hover:underline mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-sm">
          <h1 className="heading-1 mb-8">Privacy Policy</h1>
          <p className="body-small text-[var(--text-muted)] mb-8">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <div className="space-y-8">
            <section>
              <h2 className="heading-2 mb-4">1. Introduction</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                Infiniti Health ("we," "our," or "us") is committed to protecting the privacy and security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
              </p>
            </section>

            <section>
              <h2 className="heading-2 mb-4">2. Information We Collect</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-3">
                We collect information that you provide directly to us, including:
              </p>
              <ul className="list-disc list-inside space-y-2 body-medium text-[var(--text-secondary)] ml-4">
                <li>Personal identification information (name, email address, phone number)</li>
                <li>Medical and insurance information necessary for processing claims</li>
                <li>Financial information required for reimbursement processing</li>
                <li>Communication records and correspondence</li>
                <li>Usage data and website analytics</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-2 mb-4">3. How We Use Your Information</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-3">
                We use the information we collect to:
              </p>
              <ul className="list-disc list-inside space-y-2 body-medium text-[var(--text-secondary)] ml-4">
                <li>Provide and manage our healthcare support services</li>
                <li>Process insurance claims and reimbursements</li>
                <li>Communicate with you about our services</li>
                <li>Comply with legal and regulatory requirements</li>
                <li>Improve our services and website functionality</li>
                <li>Protect against fraud and unauthorized access</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-2 mb-4">4. Information Sharing and Disclosure</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                We may share your information with:
              </p>
              <ul className="list-disc list-inside space-y-2 body-medium text-[var(--text-secondary)] ml-4">
                <li>Healthcare providers and hospitals for treatment coordination</li>
                <li>Insurance companies and TPAs for claim processing</li>
                <li>Partnered NBFCs for financing services</li>
                <li>Legal authorities when required by law</li>
                <li>Service providers who assist in our operations (under confidentiality agreements)</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-2 mb-4">5. Data Security</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                We implement appropriate technical and organizational security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the Internet is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="heading-2 mb-4">6. Your Rights</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-3">
                You have the right to:
              </p>
              <ul className="list-disc list-inside space-y-2 body-medium text-[var(--text-secondary)] ml-4">
                <li>Access and obtain a copy of your personal information</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information (subject to legal requirements)</li>
                <li>Object to processing of your information</li>
                <li>Withdraw consent where processing is based on consent</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-2 mb-4">7. Data Retention</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law.
              </p>
            </section>

            <section>
              <h2 className="heading-2 mb-4">8. Cookies and Tracking Technologies</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                Our website may use cookies and similar tracking technologies to enhance user experience and analyze website traffic. You can control cookie settings through your browser preferences.
              </p>
            </section>

            <section>
              <h2 className="heading-2 mb-4">9. Changes to This Privacy Policy</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date.
              </p>
            </section>

            <section>
              <h2 className="heading-2 mb-4">10. Contact Us</h2>
              <p className="body-medium text-[var(--text-secondary)] mb-4">
                If you have any questions about this Privacy Policy or our data practices, please contact us at:
              </p>
              <div className="bg-[var(--accent-blue-200)] rounded-lg p-6 mt-4">
                <p className="body-medium text-[var(--text-primary)]">
                  <strong>Infiniti Health</strong><br />
                  #3 1st Floor, Opp Sahana Vidya Mandir<br />
                  Naganathapura, Bangalore - 560100<br />
                  Email: info@infiniti-health.com<br />
                  Phone: 7676620620
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
